import {
    AsGrid,
    AsSelect,
    IconClose,
    LabelledTickbox,
    Spacer
} from '@adserve/adserve-react-components';
import React, { useContext, useEffect, useState } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { defaultPageInfo } from '../../../services/AsGridService';
import { GetProperties } from '../../../services/DataService';
import { sectionedPanelStyle } from '../CampaignStyles';
import { columnDefinition } from './PropertyGridColumnDefinitions';
import { labelStyle, sectionTitleStyle } from './ShowStyles';

const ShowPropertiesPanel = ({
    show,
    campaignProperties,
    onRequestClick,
    onClose,
    readOnly = false
}) => {
    const [properties, setProperties] = useState([]);
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [demographics, setDemographics] = useState([]);
    const [apiParams, setApiParams] = useState({
        showId: show.id,
        demographicId: null,
        displaySponsorship: true,
        displayPartnership: true
    });

    const { dateFormat } = useContext(SystemSettingsContext);

    useEffect(() => {
        GetProperties(apiParams)
            .then((data) => setProperties(data.data))
            .catch(console.log);
    }, [apiParams]);

    const handleDemographicChange = (event) => {
        setApiParams((prevState) => {
            return {
                ...prevState,
                demographicId: event.target.value
            };
        });
    };

    const handleDisplaySponsorshipTick = () => {
        setApiParams((prevState) => {
            return {
                ...prevState,
                displaySponsorship: !prevState.displaySponsorship
            };
        });
    };

    const handleDisplayPartnershipTick = () => {
        setApiParams((prevState) => {
            return {
                ...prevState,
                displayPartnership: !prevState.displayPartnership
            };
        });
    };

    const handlePrimaryColumnClick = (show) => {
        alert('Redirect to the property');
    };

    return (
        <div style={{ ...sectionedPanelStyle, padding: '20px 40px 40px' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <span style={sectionTitleStyle}>{show.name}</span>
                <IconClose
                    id='close'
                    style={{
                        width: 17,
                        height: 17,
                        cursor: 'pointer'
                    }}
                    onClick={onClose}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}
                id='top'
            >
                <div style={{ display: 'flex' }}>
                    <LabelledTickbox
                        id='displaySponsorship'
                        title='Show Sponsorships'
                        reverseElements
                        gap={8}
                        size={20}
                        onClick={handleDisplaySponsorshipTick}
                        value={apiParams.displaySponsorship}
                    />
                    <Spacer width={30} />
                    <LabelledTickbox
                        id='displayPartnership'
                        title='Show Partnerships'
                        reverseElements
                        gap={8}
                        size={20}
                        onClick={handleDisplayPartnershipTick}
                        value={apiParams.displayPartnership}
                    />
                </div>
                <AsSelect
                    id='demographic'
                    name='demographic'
                    title='Demographic'
                    labelStyle={labelStyle}
                    values={demographics}
                    value={apiParams.demographicId}
                    onChange={handleDemographicChange}
                    style={{ width: 355 }}
                />
            </div>
            <div id='grid'>
                <AsGrid
                    style={{
                        borderLeft: '1px solid rgb(215, 215, 215)'
                    }}
                    showColumnFilter={false}
                    locale='en-GB'
                    currency='GBP'
                    dateFormat={dateFormat}
                    headerRowHeight={53}
                    pageInfo={pageInfo}
                    columnDefs={columnDefinition(
                        onRequestClick,
                        campaignProperties,
                        readOnly
                    )}
                    data={properties}
                    primaryColumn='name'
                    onSortOrderChange={() =>
                        console.log('header clicked to sort')
                    }
                    onPrimaryColumnClick={handlePrimaryColumnClick}
                    maxDataRows={5}
                    maxHeight={350}
                />
            </div>
        </div>
    );
};

export default ShowPropertiesPanel;
